import {Options, Round, Separator} from './types';

const defaultOptions: Options = {
  prefix:  '',
  suffix:  '',
  groupSeparator: Separator.DOT,
  radix: Separator.COMMA,
  decimals: 2,
  round: Round.ROUND,
  separateGroups: true,
  alwaysShowDecimals: false,
}

const getOptions = (opt?: Options): Options => {
  if (!opt) return defaultOptions;
  if (opt.radix && opt.groupSeparator && opt.radix === opt.groupSeparator) {
    // No error, radix is leading
    opt.groupSeparator = opt.radix === Separator.DOT ? Separator.COMMA : Separator.DOT;
  } 
  if (!opt.radix && opt.groupSeparator) {
    opt.radix = opt.groupSeparator === Separator.DOT ? Separator.COMMA : Separator.DOT;
  }
  if (!opt.groupSeparator && opt.radix) {
    opt.groupSeparator = opt.radix === Separator.DOT ? Separator.COMMA : Separator.DOT;
  }
  return { ...defaultOptions, ...opt };
}

export default getOptions;
